module.exports = __webpack_public_path__ + "img/animal-lab-2.05aa9bb8.png";